import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

import DefRoutes from "../../routes/routes.json";
import t from "../../i18n/i18n";
import initPage from "../../utils/initPage";
import useApi from "../../services/api";

import Template from "../../template/template";
import Header from "./header/header";

function Themes() {
  initPage({ title: "" });

  const { theme: type, id } = useParams();

  console.log("id", id);

  const { ApiGetFaqTheme } = useApi();
  const [theme, setTheme] = useState([]);

  async function getTheme() {
    const { data } = await ApiGetFaqTheme({ type });

    if (id) {
      for (const d of data) {
        if (`${d.id}` === `${id}`) {
          d.active = true;
        }
      }
    } else if (data[0]) {
      data[0].active = true;
    }

    setTheme(data);
  }

  useEffect(() => {
    getTheme();
  }, [type]);

  function activeFaq(id) {
    setTheme(
      theme.map((T) => {
        if (T.active) {
          T.active = false;
          return T;
        }

        if (T.id === id) {
          T.active = true;
          return T;
        }

        return T;
      }),
    );
  }

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="support-warp">
              <div className="support-warp-main">
                <Header />

                <div className="support-content">
                  {/* <div className="support-search">
                    <h4>{t("Support.Search")}</h4>
                    <div className="input-text icon-search">
                      <input type="text" value="" pattern="" />
                    </div>
                  </div> */}

                  <div className="side-bar-intro-warp">
                    <h2 className="text-uppercase">{t(`Support.Themes.${type}`)}</h2>

                    <div className="content-side">
                      <nav className="content-sub-nav">
                        <ul>
                          <li className={type === "Account" && "active"}>
                            <Link to={DefRoutes.Themes.replace(":theme", "Account")}>
                              {t("Support.Themes.Account")}
                            </Link>
                          </li>
                          <li className={type === "Technical" && "active"}>
                            <Link to={DefRoutes.Themes.replace(":theme", "Technical")}>
                              {t("Support.Themes.Technical")}
                            </Link>
                          </li>
                          <li className={type === "Payment" && "active"}>
                            <Link to={DefRoutes.Themes.replace(":theme", "Payment")}>
                              {t("Support.Themes.Payment")}
                            </Link>
                          </li>
                          <li className={type === "Others" && "active"}>
                            <Link to={DefRoutes.Themes.replace(":theme", "Others")}>{t("Support.Themes.Others")}</Link>
                          </li>
                        </ul>
                      </nav>
                    </div>
                    <div className="content-side-barintro">
                      <div className="intro">
                        {theme.map((T) => {
                          return (
                            <p>
                              <Link to={DefRoutes.ResponseFaq.replace(":id", T.id)}>{T.title}</Link>
                            </p>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default Themes;
